import "./RaikoInputStyleSheet.scss"
import React, {Component} from 'react';
import {TextField} from "@mui/material";
import PropTypes from "prop-types";

const RaikoMaterialOutlinedInput = (
    {
        labelText,
        placeHolder,
        value,
        setValue,
        onChange,
        spellCheck = false,
        inputId,
        className,
        InputProps,
        rows,
        multiline,
        disabled,
        type,
        maxLength,
        readOnly,
        helperText,
        error,
        required = false
    }) => {

    return (
        <div className="outlined-input-container">
            <TextField
                value={value}
                onChange={e => {
                    if (onChange)
                        onChange(e)

                    if (setValue)
                        setValue(e.target.value)

                }}
                variant="outlined"
                label={labelText}
                minRows={rows}
                maxLength={maxLength}
                id={inputId}
                className={`form-control ${className}`}
                placeholder={placeHolder}
                spellCheck={spellCheck}
                InputProps={InputProps}
                multiline={multiline}
                disabled={disabled}
                type={type}
                helperText={helperText}
                error={error}
                required={required}
            />
        </div>
    )
}

RaikoMaterialOutlinedInput.propTypes = {
    type: PropTypes.oneOf(["number", "text", "checkbox"]),
    spellCheck:PropTypes.bool,
}


export default RaikoMaterialOutlinedInput;